module.exports = {"meta":"Disclaimer"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/disclaimer.json
// module id = 7Ygw
// module chunks = 1